import React from "react";
import { Grid } from "@material-ui/core";
import CounterHelpText from "./CounterHelpText";
import InventoryHelpText from "./InventoryHelpText";
import UsageHelpText from "./UsageHelpText";
import SessionHelpText from "./SessionHelpText";
import MarcHelpText from "./MarcHelpText";
import IapSelectHelpText from "./IapSelectHelpText";
import KbartHelpText from "./KbartHelpText";

const HelpText = ({ tab }) => {
  return (
    <Grid item xs>
      {tab === 0 && <CounterHelpText />}
      {tab === 1 && <InventoryHelpText />}
      {tab === 2 && <UsageHelpText />}
      {tab === 3 && <SessionHelpText />}
      {tab === 4 && <MarcHelpText />}
      {tab === 5 && <KbartHelpText />}
      {tab === 6 && <IapSelectHelpText />}
    </Grid>
  );
};

export default HelpText;
